import React from "react";
import Shell from "../../Shell/Shell";
import { Grid } from "@mui/material";
import KPIPerfomancePresenter from "./KPIPerfomancePresenter";
import DTOKPIPerfomance from "./DTOKPIPerfomance";
import _ from "lodash";
import { useTranslation } from "react-i18next";

interface Prop {
  trans: any;
  myTeam: boolean;
}
function KPIPerfomanceController({ trans,myTeam }: Prop) {
  const { t, i18n } = useTranslation();

  return (
    <>
      <Shell>
        <Grid container>
          <KPIPerfomancePresenter trans={trans} myTeam={myTeam}/>
        </Grid>
      </Shell>
      <DTOKPIPerfomance />
    </>
  );
}
export default KPIPerfomanceController;
